"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OurTeamComponent = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var ansie_h_png_1 = __importDefault(require("../../../assets/our_team/ansie_h.png"));
var christopher_w_jpeg_1 = __importDefault(require("../../../assets/our_team/christopher_w.jpeg"));
var claudia_v_jpeg_1 = __importDefault(require("../../../assets/our_team/claudia_v.jpeg"));
var jaco_d_jpeg_1 = __importDefault(require("../../../assets/our_team/jaco_d.jpeg"));
var OurTeamComponent = function (props) {
    var _a = props;
    var teamMembers = (0, react_1.useState)([
        {
            name: "Christopher Williams",
            position: "CEO",
            image: christopher_w_jpeg_1.default,
        },
        {
            name: "Jaco Du Plessis",
            position: "General Manager",
            image: jaco_d_jpeg_1.default,
        },
        {
            name: "Ansie Hartman",
            position: "Clinic Manager",
            image: ansie_h_png_1.default,
        },
        {
            name: "Claudia Van Schalkwyk",
            position: "Field Service Advisor Manager",
            image: claudia_v_jpeg_1.default,
        },
    ])[0];
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Our team.", size: "3xlarge", textColor: "text-black", bold: true }),
            react_1.default.createElement("div", { className: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" }, teamMembers.map(function (member, index) {
                return (react_1.default.createElement("div", { key: index, className: "flex flex-col gap-4 hover:scale-110 transition" },
                    react_1.default.createElement("div", { className: "aspect-square rounded-lg shadow-lg overflow-hidden" },
                        react_1.default.createElement("img", { src: member.image, className: "w-full h-full object-cover" })),
                    react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: member.name, size: "medium", textColor: "text-primary", bold: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: member.position, size: "small", textColor: "text-success" }))));
            })))));
};
exports.OurTeamComponent = OurTeamComponent;
